// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 814 ? "vendor-shared-kit" : chunkId) + "." + {"700":"06b372943c76a367daa6","814":"8f5b3801c6bd4e099a65"}[chunkId] + ".css";
};